// import { USER_INFO } from "../actions";

const initalState = {};

const user = (state = initalState, action) => {
  return state;
};

export default user;
